import { ActionTypes } from './actionTypes';

export const setVisible = (payload) => ({
  type: ActionTypes.SET_IS_VISIBLE,
  payload,
});
export const setVisibleCharts = (payload) => ({
  type: ActionTypes.SET_IS_VISIBLE_CHARTS,
  payload,
});